/**
 * The image files are square, the portrait motif padded with white bars. `portrait` clips
 * the bars at 6.5:10, not the nominal 7:10: masters vary, and a wider frame leaves a white
 * edge where a narrower one only loses ~7% of the width.
 */
export const TILE_FRAME = {
  portrait: { aspect: 'aspect-[6.5/10]', fit: 'object-cover' },
  square: { aspect: 'aspect-square', fit: 'object-contain' },
};

/** Below 450px no explicit columns, so the slider's auto columns size every tile. */
export const GRID_CLASS_NAME =
  'scrollbar-hide m-0 grid list-none gap-0.5 p-0 *:relative *:m-0 *:w-full *:snap-start *:snap-always @min-[450px]/imggrid:grid-cols-2 @min-[904px]/imggrid:grid-cols-3 @min-[1360px]/imggrid:grid-cols-4';

export const SLIDER_CLASS_NAME =
  'imggrid-slider:grid-flow-col imggrid-slider:auto-cols-[80%] imggrid-slider:overflow-x-auto imggrid-slider:overscroll-x-contain imggrid-slider:snap-x imggrid-slider:snap-mandatory imggrid-slider:[scroll-timeline:--imggrid-scroll_inline]';

/** Tiles that span the hero area; the span only fits from two columns on. */
export const TILE_HERO_CLASS_NAME =
  '@min-[450px]/imggrid:col-span-2 @min-[450px]/imggrid:row-span-2';
